<!-- 筛选 -->
<template>
  <div>
    <!-- 头部导航条 -->
    <van-nav-bar title="筛选" fixed placeholder z-index="100" @click-left="onClickLeft">
      <template #left>
        <img src="@/assets/img/home/close.png" class="nav-img" />
      </template>
    </van-nav-bar>
    <!-- 学历要求 -->
    <div class="degree">
      <p>学历要求</p>
      <div class="degree-box">
        <div
          :class="{'degree-item':true,'actived':item.category_id==edId}"
          v-for="(item, index) in education"
          :key="index"
          @click="checkTap(item.category_id,index,'0')"
        >{{item.name}}</div>
      </div>
    </div>

    <!-- 期望月薪 -->
    <div class="degree">
      <p>期望月薪</p>
      <div class="degree-box">
        <!--  -->
        <div
          :class="{'degree-item':true,'actived':index==waIndex}"
          v-for="(item, index) in wage"
          :key="index"
          @click="checkTap(item,index,'1')"
        >{{item}}</div>
      </div>
    </div>

    <!-- 经验要求 -->
    <div class="degree">
      <p>经验要求</p>
      <div class="degree-box">
        <div
          :class="{'degree-item':true,'actived':item.category_id==exId}"
          v-for="(item, index) in experience"
          :key="index"
          @click="checkTap(item.category_id,index,'2')"
        >{{item.name}}</div>
      </div>
    </div>

    <!-- 是否退役军人 -->
    <!-- <div class="degree">
      <p>是否退役军人（可选）</p>
      <div class="degree-box">
        <div class="degree-item actived">退役士兵</div>
        <div class="degree-item">士官</div>
        <div class="degree-item">转业士官</div>
      </div>
    </div>-->
    <!-- 按钮 -->
    <div class="btn">
      <button class="clear" @click="bindTap(0)">清除</button>
      <button class="confirm" @click="bindTap(1)">确定</button>
    </div>
  </div>
</template>

<script>
import { getKindArray } from "@/api/apiData";
import { mapMutations, mapState } from "vuex";
import { Toast, Dialog } from "vant";
export default {
  components: {},
  data() {
    return {
      wage: ["3k以下", "3-5k", "5-8k", "8-12k", "12-20k", "20-25k", "25k以上"], //月薪
      education: [], //学历分类
      experience: [], //工作经验分类
      current: [], //年龄段分类
      edIndex: -1,
      waIndex: -1,
      exIndex: -1,
      edId: "-1", //学历项id
      waId: "-1", //薪资项id
      exId: "-1", //经验项id
      entrance: "", //0 首页 1搜索
      arr: []
    };
  },
  computed: {
    ...mapState(["list"])
  },
  methods: {
    ...mapMutations(["select", "selectNum"]),
    //点击左侧导航栏按钮
    onClickLeft() {
      this.$router.back();
    },
    // 获取分类数据
    getKinds(val) {
      var that = this;
      var paramsObj = {
        key: val
      };
      getKindArray(paramsObj).then(res => {
        // //(res);
        if (res.code == 1) {
          switch (val) {
            case "wage": // 获取月薪
              that.getKinds("education");
              // that.wage = res.data;
              // if(that.list[1].length>0){

              if (that.list.length > 0) {
                that.wage.forEach((item, index) => {
                  if (item == "3k以下") {
                    item = ["", "3000"];
                  }
                  if (item == "25k以上") {
                    item = ["25000", ""];
                  }
                  if (item.lastIndexOf("k") != -1) {
                    item = item.split("-");
                    var items = item[1].replace("k", "000");
                    item = [`${item[0]}000`, items];
                  }
                  if (
                    item[0] == that.list[1][0] &&
                    item[1] == that.list[1][1]
                  ) {
                    that.waIndex = index;
                  }
                });
              }
              break;
            case "education": // 获取学历分类
              that.getKinds("experience");
              that.education = res.data;
              that.education.forEach(item => {
                if (item.category_id === that.list[0]) {
                  that.edId = that.list[0];
                }
              });
              break;
            case "experience": // 获取工作经验
              that.experience = res.data;
              that.experience.forEach(item => {
                if (item.category_id === that.list[2]) {
                  that.exId = that.list[2];
                }
              });
              break;
          }
        }
      });
    },
    // 选择分类项
    checkTap(name, index, type) {
      var that = this;
      switch (type) {
        case "0": //学历
          that.edIndex = index;
          that.edId = name;
          // that.select([name, 0]);
          break;
        case "1": //期望月薪
          that.waIndex = index;
          if (name == "3k以下") {
            name = ["", "3000"];
          }
          if (name == "25k以上") {
            name = ["25000", ""];
          }
          if (name.lastIndexOf("k") != -1) {
            name = name.split("-");
            var item = name[1].replace("k", "000");
            name = [`${name[0]}000`, item];
          }
          that.waId = name;
          // that.select([name, 1]);
          break;
        case "2": //工作经验
          that.exIndex = index;
          that.exId = name;
        // that.select([name, 2]);
      }
    },
    // 确定 清除
    bindTap(val) {
      const that=this;
      let { edIndex, waIndex, exIndex, edId, waId, exId } = this;
      if (val == 0) {
        if (that.list.length == 0) {
          Dialog.alert({
            title: "提示",
            message: "您还没有选择任何条件哦~"
          }).then(() => {});
        } else {
          Dialog.confirm({
            title: "提示",
            message: "确定要全部清理已经选择的条件项吗？"
          })
            .then(() => {
              this.selectNum("");
              this.select(0);
              this.edId = "-1";
              this.exId = "-1";
              this.waIndex = "-1";
              Toast.success({
                forbidClick: true,
                message: "清除成功" 
              });
            })
            .catch(() => {
              // on cancel
            });
        }
      } else {
        if (edIndex > -1 || waIndex > -1 || exIndex > -1) {
          this.selectNum(1);
        } else {
          Toast("您还没有选择任何一个筛选条件哦~");
          return false;
        }
        if (
          (edIndex > -1 && waIndex > -1) ||
          (edIndex > -1 && exIndex > -1) ||
          (waIndex > -1 && exIndex > -1)
        ) {
          this.selectNum(2);
        }
        if (edIndex > -1 && waIndex > -1 && exIndex > -1) {
          this.selectNum(3);
        }
        var name = [edId, waId, exId, this.entrance];
        this.select(name);
        this.$router.back();
      }
    }
  },
  created() {
    // //(this.$route);
    this.entrance = this.$route.query.entrance;
    // if (this.entrance == 0) {
    //   this.arr = this.list;
    //   if(this.arr[1][1]==''){
    //     this.arr[1]='3k以下'
    //   }
    //    if(this.arr[1][0]==''){
    //     this.arr[1]='25k以上'
    //   }
    //   //(this.arr[1]);

    //   if(this.arr[1].length>0){
    //     alert(11)
    //     this.arr[1]=this.arr[1][1].replace('0')
    //     //(this.arr[1]);

    //   }

    // } else {
    //   this.arr = this.lists;
    // }
  },
  mounted() {
    this.getKinds("wage");
  }
};
</script>
<style lang='less' scoped>
.nav-img {
  width: 0.4rem;
  height: 0.4rem;
}
//学历要求
.degree {
  padding: 0.45rem 0.32rem 0;
  p {
    font-size: 0.32rem;
    font-weight: bold;
    line-height: 0.45rem;
    color: rgba(51, 51, 51, 1);
    text-align: left;
    padding-bottom: 0.18rem;
  }
  .degree-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 0.24rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    .degree-item {
      width: 30%;
      padding: 0.16rem 0;
      text-align: center;
      background: rgba(248, 248, 248, 1);
      border-radius: 0.08rem;
      margin: 0.1rem;
      border: 0.01rem solid rgba(248, 248, 248, 1);
    }
    // 选中
    .actived {
      background: rgba(255, 238, 238, 1);
      color: #ff4343;
      border: 0.01rem solid #ff4343;
    }
  }
}
.degree:nth-child(5)::after {
  content: "";
  display: block;
  height: 1.5rem;
}
</style>